// extracted by mini-css-extract-plugin
export default {"modalContent":"D7-z"};